<template>
  <div class="">
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="kreditgenie-text-green hover:kreditgenie-text-green-hover"
                    :href="route('documents')"
      >
        Dokumente
      </inertia-link>
      <span class="kreditgenie-text-green font-medium">/</span>
      {{ form.type }}
    </h1>
    <trashed-message v-if="document.deleted_at" class="mb-6" @restore="restore">
      Dieses Dokument ist im Papierkorb. Möchten Sie es wiederherstellen?
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <select-input v-model="form.type" label="Typ" class="w-full lg:w-1/3">
            <option v-for="docType in docTypes()" :key="docType.key" :value="docType.key">
              {{ docType.value }}
            </option>
          </select-input>
        </div>
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
          <textarea-input
            v-model="form.text"
            :error="form.errors.text"
            class="pr-6 pb-0 mb-0 w-full lg:w-full"
            label="Texte"
            rows="15"
          />
          <small class="pb-8 pt-2">(tags wie <b>[gender]</b>, <b>[first_name]</b>, <b>[last_name]</b> und <b>[credit_amount]</b> werden ersetzt)</small>
        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button
            v-if="!document.deleted_at"
            class="text-red-600 hover:underline"
            tabindex="-1"
            type="button"
            @click="destroy"
          >
            Löschen
          </button>
          <button
            v-if="document.deleted_at"
            class="text-green-600 hover:underline"
            tabindex="-1"
            type="button"
            @click="restore"
          >
            Wiederherstellen
          </button>
          <loading-button :loading="form.processing" class="btn-green ml-auto" type="submit">
            Aktualisieren
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'

import SelectInput from '../../Shared/SelectInput.vue'
import {docTypes} from './docTypes'
import TextareaInput from '../../Shared/TextareaInput.vue'

export default {
  components: {
    TextareaInput,
    SelectInput,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    document: Object,
    tinyMceApiKey: String,
  },
  data() {
    return {
      form: this.$inertia.form({
        'type': this.document.type,
        'text': this.document.text,
      }),
    }
  },
  metaInfo() {
    return {
      title: `${this.document.type} - Dokumente`,
    }
  },
  remember: 'form',
  methods: {
    docTypes() {
      return docTypes
    },
    update() {
      this.form.post(this.route('documents.update', this.document.id).url(), {
        onSuccess: () => this.form.reset('photo'),
      })
    },
    destroy() {
      if (confirm('Möchten Sie dieses Dokument wirklich löschen?')) {
        this.$inertia.delete(this.route('documents.destroy', this.document.id))
      }
    },
    restore() {
      if (confirm('Möchten Sie dieses Dokument wirklich wiederherstellen?')) {
        this.$inertia.put(this.route('documents.restore', this.document.id))
      }
    },
  },
}
</script>
